module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"totalInvoices":"Total Invoices"},"al":{"totalInvoices":"Të gjithë faturat"}}')
  delete Component.options._Ctor
}
